import { fetchAxios } from "../API/fetchAxios";

export const listPixKeysRequest = () =>
  fetchAxios({ verb: "GET", context: "pixKeys" });

export const getPixKeyRequest = (id) =>
  fetchAxios({ verb: "GET", context: "pixKeyDetail", id });

export const createPixKeyRequest = (body) =>
  fetchAxios({ verb: "POST", context: "pixKeyCreate", body });

export const deletePixKeyRequest = (id) =>
  fetchAxios({ verb: "DELETE", context: "pixKeyDelete", id });

/** Link owned key → virtual WALLET (`POST …/keys/{id}/link`). */
export const linkPixKeyRequest = (id, linkedAccountId, originAccountId = null) =>
  fetchAxios({
    verb: "POST",
    context: "pixKeyLink",
    id,
    afterID: "link",
    body: {
      linked_account_id: linkedAccountId,
      ...(originAccountId ? { origin_account_id: originAccountId } : {}),
    },
  });

/** Remove active virtual link (`DELETE …/keys/{id}/link`). */
export const unlinkPixKeyRequest = (id, originAccountId = null) =>
  fetchAxios({
    verb: "DELETE",
    context: "pixKeyUnlink",
    id,
    afterID: "link",
    queryParameters: originAccountId
      ? { origin_account_id: originAccountId }
      : null,
  });
